export { VehicleModel } from "./vehicles.model";
export { VehiclesService } from "./vehicles.service";
